module.exports = __webpack_public_path__ + "media/src/images/petal_cutted-365b45e4d3a2cc804fa65cc49f51bfc0.png";